(() => {
    // NOT signed in flow - checking age gate...
    const hasCookie = (cookieName) => document.cookie.split('; ').some((cookie) => cookie.startsWith(`${cookieName}=`));
    if (!hasCookie('validAge')) return;

    // NOT signed in flow - redirecting to login...
    window.location.replace('/account/login');
})();